import React, { useEffect } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import NotificationItem from './NotificationItem';
import './styles/Notifications.css';

const NotificationDropdown = ({ onClose }) => {
  const { 
    notifications, 
    loading, 
    error, 
    markAllAsRead,
    loadNotifications 
  } = useNotifications();

  // Load fresh notifications when dropdown opens
  useEffect(() => {
    loadNotifications();
  }, [loadNotifications]);

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
    onClose();
  };

  return (
    <div className="notification-dropdown">
      <div className="notification-header">
        <h3>
          <i className="fas fa-bell"></i>
          Notifications
        </h3>
        {notifications.length > 0 && (
          <button 
            className="mark-all-read-btn"
            onClick={handleMarkAllAsRead}
            disabled={loading}
          >
            Mark All Read
          </button>
        )}
      </div>

      <div className="notification-content">
        {loading && (
          <div className="notification-loading">
            <i className="fas fa-spinner fa-spin"></i>
            Loading notifications...
          </div>
        )}

        {error && (
          <div className="notification-error">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        {!loading && !error && notifications.length === 0 && (
          <div className="notification-empty">
            <i className="fas fa-bell-slash"></i>
            <p>No notifications yet</p>
            <span>You'll see updates here when they happen</span>
          </div>
        )}

        {!loading && notifications.length > 0 && (
          <div className="notification-list">
            {notifications.slice(0, 10).map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                onClose={onClose}
              />
            ))}
          </div>
        )}

        {!loading && notifications.length > 10 && (
          <div className="notification-footer">
            <button className="view-all-btn" onClick={onClose}>
              View All Notifications
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
